const translations = {
  // Navigation
  'nav.home': 'Home',
  'nav.records': 'Anson Road Records',
  'nav.licensingPublishing': 'Licensing + Publishing',
  'nav.management': 'Management',
  'nav.contact': 'Contact',
  'nav.submitMusic': 'Submit Music',

  // Hero Section
  'hero.tagline': 'Rooted in Texas and shaped by the sounds of its culture, Santos Music Group and Anson Road Records releases music with grit, corazón, and miles on it — where the old ways still matter, and the next chapter arrives naturally.',
  'hero.exploreSound': 'Explore the Sound',
  'hero.submitMusic': 'Submit Music',
  'hero.scroll': 'Scroll',

  // About Section
  'about.quote1': '"Country music didn\'t arrive here — it\'s always been here."',
  'about.paragraph1': 'Across <strong>Texas,</strong>&nbsp;the Southwest, and Northern Mexico, the sound has lived close to the land — shaped by working towns, border highways, dance halls, and generations of stories, from conjunto rhythms to red dirt roads.',
  'about.paragraph2': '<strong>Santos Music Group/Anson Road Records</strong>&nbsp;is a modern <strong>Texas Country and Latin Country</strong>&nbsp;label dedicated to artists who tell the truth — whether their influence comes in English or Spanish, Country tradition, Tejano, Regional, or backroad Americana. We honor the music that\'s always been part of this land.',
  'about.paragraph3': 'Through our partnership with <strong>RanchFire Radio</strong>, we connect our artists directly to listeners across Texas, the Southwest, and beyond — giving them airplay, exposure, and a platform built for the music that matters. It\'s more than distribution — it\'s a shared mission to amplify authentic voices and keep the sound alive where it belongs: on the radio, in the truck, and out on the road.',
  'about.quote2': '"We put the song first. The music speaks for itself."',

  // Divisions Section
  'divisions.title': 'What We Do',
  'divisions.records.title': 'Records Division',
  'divisions.records.description': 'Selective releases from modern Texas Country artists shaping the next era — honoring tradition while building something new.',
  'divisions.publishing.title': 'Publishing Division',
  'divisions.publishing.description': 'Songwriter-first catalog building, rights administration, and long-term value for stories told in any language.',
  'divisions.licensing.title': 'Licensing Division',
  'divisions.licensing.description': 'Sync-ready music for film, TV, trailers, brands, and culture — authentic sounds that connect.',
  'divisions.management.title': 'Artist Management',
  'divisions.management.description': 'Hands-on development, strategy, and career guidance for breakout talent from all backgrounds.',
  'divisions.cta': 'Work With us',

  // Management Page
  'management.hero.title': 'Artist Management',
  'management.hero.intro': 'We work with a <strong>small number of artists</strong> at a time — helping develop sound, story, touring strategy, and long-term positioning.',
  'management.focus.title': 'Management Focus:',
  'management.focus.strategy.title': 'Career Strategy',
  'management.focus.strategy.description': 'Long-term vision and positioning for sustainable growth in the modern Texas Country landscape.',
  'management.focus.release.title': 'Release Planning',
  'management.focus.release.description': 'Strategic rollouts, timing, and coordination across all platforms and media channels.',
  'management.focus.brand.title': 'Brand Partnerships',
  'management.focus.brand.description': 'Authentic collaborations with heritage brands, lifestyle companies, and cultural institutions.',
  'management.focus.live.title': 'Live Growth + Festival Lanes',
  'management.focus.live.description': 'Building touring infrastructure, festival presence, and regional strongholds across Texas and beyond.',
  'management.focus.crossBorder.title': 'Cross-Border Opportunity',
  'management.focus.crossBorder.description': 'Leveraging Texas ↔ Mexico cultural connections for bilingual and bicultural artist development.',
  'management.cta': 'Apply for Management',

  // Artists Page
  'artists.hero.title': 'Roster & Submissions',
  'artists.hero.intro': 'We represent a select group of writers and artists creating the next chapter of authentic country music.',
  'artists.roster.title': 'Featured Writers & Artists',
  'artists.roster.subtitle': 'A curated roster of talent creating authentic alt-country and Texas-rooted music.',

  // Licensing Page
  'licensing.hero.title': 'Music Licensing & Sync',
  'licensing.hero.intro': 'Unwound Sound offers a curated roster of authentic alt-country and Texas-rooted recordings available for sync.',

  // Publishing Page
  'publishing.hero.title': 'Publishing & Songwriting',
  'publishing.hero.intro': 'Great songs are assets. We build catalogs that last.',

  // Records Page
  'records.hero.title': 'The Label',
  'records.hero.intro': 'Anson Road Records is home for modern <strong>Texas Country</strong> artists who live outside the polished — music that feels real, lived-in, and undeniable.',
  'records.hero.whatWeRelease': 'What We Release',
  'records.hero.texasCountry': '<strong>Texas Country</strong> & Latino Country',
  'records.hero.altCountry': 'Alt-country & <strong>Americana</strong>',
  'records.hero.borderland': '<strong>Borderland</strong> storytelling',
  'records.hero.crossover': 'Crossover voices shaping the <strong>future</strong> of the genre',

  // Footer
  'footer.tagline': 'Modern Texas Country Label',
  'footer.services': 'Music • Publishing • Licensing • Artist Management',
  'footer.slogan': 'Rooted in Texas. Built for the long haul. For everyone.',
  'footer.navigate': 'Navigate',
  'footer.stayConnected': 'Stay Connected',
  'footer.newsletterText': 'Get new releases, sync music, and artist discoveries',
  'footer.emailPlaceholder': 'YOUR EMAIL',
  'footer.subscribe': 'Subscribe',
  'footer.subscribing': 'Subscribing...',
  'footer.thankYou': 'Thanks for subscribing!',
  'footer.error': 'Something went wrong. Try again.',
  'footer.copyright': '© 2026 Anson Road Records, subsidiary of ranchfire multimedia, llc. All Rights Reserved.',
};

export default translations;
